<template>

	<div class="popup">
		<span>点击选择“添加到我的小程序”，就可以轻松购物啦~</span>
		<div class="close">
			<van-icon name="clear" size="16" @click="closeapplets" />
		
	</div>
	</div>


</template>

<script>

export default {
	data() {
		return {

		};
	},
	methods: {
		click() {
			this.$emit("buttonClick");
		},
	},
	mounted() {

	}
};
</script>

<style scoped lang="scss">
	.popup {
		display: flex;
		align-items: center;
		width: 450px;
		background: #111;
		padding: 15px 20px;
		border-radius: 15px;
		position: fixed;
		top: 30px;
		right: 30px;
		border: 1px solid #111;
	}

	.popup span {
		line-height: 40px;
		font-size: 26px;
		color: #fff;
	}

	.popup .close {
		color: #fff;
		padding-left: 60px;
	}

	.popup::before {
		content: '';
		width: 0px;
		height: 0px;
		border-width: 0 20px 20px;
		border-style: solid;
		border-color: transparent transparent #111;
		left: 385px;
		top: -15px;
		position: absolute;
		margin-left: -10px;
	}
</style>
